import { GRAPH_TYPE } from "../../../../constants/trendGraph/trendGraphType";
import { DASHBOARD_ITEM_TYPE } from "../../constants";

export const addCustomTrendItem = (isSepVessel, chart, setSelectedDashboard) => {
  const graphType = chart?.graphType;
  if (!graphType) {
    return;
  }
  if (graphType === GRAPH_TYPE.ENGINE) {
    setSelectedDashboard((current) => {
      const newItems = current.items.concat({
        id: self.crypto.randomUUID(),
        position: {
          i: "engine" + current.items.length + 1,
          x: 0,
          y: Infinity, // puts it at the bottom
          w: 12,
          h: 9,
        },
        type: DASHBOARD_ITEM_TYPE.ENGINE,
        chartType: chart.chartType,
        enginePosition: chart.enginePosition,
        chartId: chart.id,
      });
      return { ...current, items: newItems };
    });
  }
  if (graphType === GRAPH_TYPE.ELECTRIC) {
    if (isSepVessel) {
      setSelectedDashboard((current) => {
        const newItems = current.items.concat({
          id: self.crypto.randomUUID(),
          position: {
            x: 0,
            y: Infinity,
            w: 12,
            h: 9,
          },
          type: DASHBOARD_ITEM_TYPE.ADDITIONAL_ELECTRIC,
          chartType: chart.chartType,
          chartId: chart.id,
        });
        return { ...current, items: newItems };
      });
    } else {
      setSelectedDashboard((current) => {
        const newItems = current.items.concat({
          id: self.crypto.randomUUID(),
          position: {
            x: 0,
            y: Infinity,
            w: 12,
            h: 9,
          },
          type: DASHBOARD_ITEM_TYPE.ELECTRIC,
          chartType: chart.chartType,
          chartId: chart.id,
        });
        return { ...current, items: newItems };
      });
    }
  }
  if (graphType === GRAPH_TYPE.SEP) {
    setSelectedDashboard((current) => {
      const newItems = current.items.concat({
        id: self.crypto.randomUUID(),
        position: {
          x: 0,
          y: Infinity,
          w: 12,
          h: 9,
        },
        type: DASHBOARD_ITEM_TYPE.SEP,
        chartType: chart.chartType,
        chartId: chart.id,
      });
      return { ...current, items: newItems };
    });
  }
  if (graphType === GRAPH_TYPE.CUSTOM) {
    const analogCount = chart.lines?.filter(line => line.digitalVar === null)?.length;
    const isCombined = analogCount > 0 && analogCount !== chart.lines.length;
    setSelectedDashboard((current) => {
      const newItems = current.items.concat({
        id: self.crypto.randomUUID(),
        position: {
          i: "custom" + current.items.length + 1,
          x: 0,
          y: Infinity, // puts it at the bottom
          w: 12,
          h: isCombined ? 18 : 9, // for combined graph
        },
        type: DASHBOARD_ITEM_TYPE.CUSTOM,
        chartId: chart.id,
      });
      return { ...current, items: newItems };
    });
  }
};

export const removeTrendGraphItem = (id, setSelectedDashboard) => {
  setSelectedDashboard((currentDashboard) => {
    const newItems = currentDashboard.items.filter((item) => {
      if (item.type === DASHBOARD_ITEM_TYPE.VALUE) return true;
      if (item.chartId !== id) return true;
      return false;
    });
    return { ...currentDashboard, items: newItems };
  });
};

export const checkTrendGraphExist = (existingTrendGraphIds, chart) => {
  const graphType = chart?.graphType;
  const chartId = chart?.id;
  if (!graphType) return true; // if graphType is not exist, it's incorrect data so shouldn't be possible to add
  return existingTrendGraphIds.includes(chartId);
};
